import {Component, Prop, Vue} from "vue-property-decorator";
import VueDatePicker from "vuejs-datepicker";
import {fr} from "vuejs-datepicker/dist/locale";

@Component
export class DatePicker extends Vue {

  @Prop({type: [Date, null]}) value: Date;
  @Prop({type: Boolean, default: true}) showClearButton: boolean;


  render() {
    return <VueDatePicker
      value={this.value}
      onInput={(v:Date) => this.$emit("input", v)}
      inputClass="input is-small"
      clear-button={this.showClearButton}
      language={fr}
    />
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2cc2c192/date-picker.tsx" });